import { render, staticRenderFns } from "./AdminVolunteersContentSection.vue?vue&type=template&id=15026593&scoped=true"
import script from "./AdminVolunteersContentSection.vue?vue&type=script&lang=js"
export * from "./AdminVolunteersContentSection.vue?vue&type=script&lang=js"
import style0 from "./AdminVolunteersContentSection.vue?vue&type=style&index=0&id=15026593&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15026593",
  null
  
)

export default component.exports